import { render, staticRenderFns } from "./AuthRegister.vue?vue&type=template&id=5faceadf&scoped=true"
import script from "./AuthRegister.vue?vue&type=script&lang=js"
export * from "./AuthRegister.vue?vue&type=script&lang=js"
import style0 from "./AuthRegister.vue?vue&type=style&index=0&id=5faceadf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faceadf",
  null
  
)

export default component.exports